import { render } from "./GroupTab.vue?vue&type=template&id=3ef66012&scoped=true"
import script from "./GroupTab.vue?vue&type=script&lang=js"
export * from "./GroupTab.vue?vue&type=script&lang=js"

import "./GroupTab.vue?vue&type=style&index=0&id=3ef66012&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef66012"]])

export default __exports__